"use client";

// Error boundary for /events and its nested routes (e.g. /events/details/[id]).
// Any unexpected render crash falls back to a friendly branded page instead of
// Next.js's default error screen.
import EventsErrorFallback from "./events-new-pages/new/EventsErrorFallback";

export default function EventsError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <EventsErrorFallback error={error} reset={reset} />;
}
